export default __webpack_public_path__ + "static/media/gallery-2-3.153416cc.webp";